import axiosClient from "./axiosClient";

const couponApi = {
  getAll: () => axiosClient.get("/promotions/?page=1&limit=10"),
  getById: (id) => axiosClient.get(`/coupons/${id}`),
  create: (data) => axiosClient.post("/admin/coupons", data),
  update: (id, data) => axiosClient.patch(`/admin/coupons/${id}`, data),
  delete: (id) => axiosClient.delete(`/admin/coupons/${id}`)
};

export default couponApi;
